/**
 * DNSSEC result for the Dane Validation test
 */
export interface IRcaDaneValidationDnsSecResult {
  /**
   * DNSSEC result status
   */
  Status: DnsSecStatus;

  /**
   * DNSSEC result details
   */
  Details: string;
}

/**
 * DNSSEC result status
 */
export enum DnsSecStatus {
  Unknown = "Unknown",
  Success = "Success",
  Disabled = "Disabled",
  FailureDnsSec = "FailureDnsSec",
  Failure = "Failure",
}
